import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useCountUp } from 'react-countup'
import { FormattedMessage } from 'react-intl'
import { Flex, Text, Heading, useTheme } from '@homebotapp/hb-react-component-catalog'
import { Lock } from '../../..'
import { selectSettingsMap } from '../../../../store/selectors/airDna'
import { formatCurrency } from '../../../../helpers/formatters'

export interface AirDnaSavingsProps {
  locked?: boolean
  stateKey: string
}

export const AirDnaSavings = ({ stateKey, locked = false }: AirDnaSavingsProps) => {
  const { theme } = useTheme()
  const settings = useSelector(selectSettingsMap)[stateKey]
  const monthlySavings = settings?.nightsPerMonth * settings?.pricePerNight

  const {
    countUp: countUpMonthly,
    start: startMonthly,
    update: updateMonthly
  } = useCountUp({
    start: 0,
    end: monthlySavings,
    duration: 1
  })

  const {
    countUp: countUpYearly,
    start: startYearly,
    update: updateYearly
  } = useCountUp({
    start: 0,
    end: monthlySavings * 12,
    duration: 1
  })

  useEffect(() => {
    updateMonthly(monthlySavings)
    updateYearly(monthlySavings * 12)
  }, [monthlySavings]) // eslint-disable-line

  useEffect(() => {
    startMonthly()
    startYearly()
  }, []) // eslint-disable-line

  return (
    <Flex direction='column'>
      <Flex
        padding={4}
        marginX={-4}
        marginTop={6}
        align='center'
        justify='space-between'
        backgroundColor={`${theme.isLightThemeType ? 'white' : 'black'}Alpha.400`}
      >
        <Heading as='h4' fontWeight='light' size='sm'>
          <FormattedMessage id='AirDna.summary.avgMonthlyRevenue' defaultMessage='Avg. Monthly Revenue' />
        </Heading>
        <Lock enabled={locked}>
          <Text as='span' color='success' size='lg'>
            {formatCurrency(Math.round(countUpMonthly as number))}
          </Text>
        </Lock>
      </Flex>
      <Flex padding={4} marginX={-4} align='center' justify='space-between'>
        <Heading as='h4' fontWeight='light' size='sm'>
          <FormattedMessage id='AirDna.summary.annualRevenue' defaultMessage='Annual Revenue' />
        </Heading>
        <Lock enabled={locked}>
          <Text as='span' color='success' size='lg'>
            {formatCurrency(Math.round(countUpYearly as number))}
          </Text>
        </Lock>
      </Flex>
    </Flex>
  )
}
